var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "flv-box" }, [
    _c("video", {
      ref: "video",
      attrs: { muted: "" },
      domProps: { muted: true },
    }),
    _vm._v(" "),
    _vm.showPlayButton
      ? _c("div", { staticClass: "play-button", on: { click: _vm.play } })
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }